var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadlight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 141,
    viewBox: "0 0 208 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 208,
    height: 140.577,
    rx: 4,
    fill: "#004552"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2856,
    y: 21.1488,
    width: 159,
    height: 99,
    rx: 4,
    fill: "#E6FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(43.5,28.2)",
    d: "M58.5161 37.6364H59.5521V46.5894H58.2221V39.2114C57.9887 39.3467 57.7507 39.4517 57.5081 39.5264C57.2654 39.5964 57.0227 39.6361 56.7801 39.6454V38.3574C57.0834 38.3201 57.3774 38.2454 57.6621 38.1334C57.9514 38.0167 58.2361 37.8511 58.5161 37.6364Z",
    fill: "#004552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlight2);
export default __webpack_public_path__ + "static/media/headlight-2.6593edddc1b5748a6df4c206acfb32a6.svg";
export { ForwardRef as ReactComponent };